import { InfoBarHostViewState } from '../schema/InfoBarMessageViewState';
import { infoBarMessageCreatorsMap } from '../utils/infoBarMessageCreatorsMap';
import { action } from 'satcheljs/lib/legacy';

/**
 * @param viewState the host viewstate storing the list of messageIds to render
 * @param messageId the message Id of the infobar to remove
 * @param key if the message is added with a key, use the key to remove it from that bucket.
 * This allows support for messages with the same id if they are scoped to a particular domain (e.g. itemId or composeId)
 */
const removeInfoBarMessageInReadingPane = action('removeInfoBarMessageInReadingPane')(
    function removeInfoBarMessageInReadingPane(
        viewState: InfoBarHostViewState,
        messageId: string,
        key: string = '0'
    ) {
        for (let i = 0; i < viewState.infoBarIds.length; i++) {
            if (viewState.infoBarIds[i] == messageId) {
                viewState.infoBarIds.splice(i, 1);
                break;
            }
        }
        if (infoBarMessageCreatorsMap[key]) {
            delete infoBarMessageCreatorsMap[key][messageId];
            if (Object.keys(infoBarMessageCreatorsMap[key]).length === 0) {
                delete infoBarMessageCreatorsMap[key];
            }
        }
    }
);

export default removeInfoBarMessageInReadingPane;
